export const TOGGLE_SIDEBAR_COLLAPSE = 'TOGGLE_SIDEBAR_COLLAPSE';

export function toggleSidebarCollapse() {
  return {
    type: TOGGLE_SIDEBAR_COLLAPSE
  }
}


// WEBPACK FOOTER //
// ./src/components/layout/layout-actions.js